import React, { type ReactNode } from 'react'

import * as S from './RoundedButton.styled'
import type { RoundedButtonSize } from './RoundedButton.types'

type RoundedButtonProps = {
  className?: string
  size?: RoundedButtonSize
  children: ReactNode
  onClick: () => void
}

export const RoundedButton = ({
  size = 'medium',
  className,
  children,
  onClick,
}: RoundedButtonProps) => {
  return (
    <S.Button className={className} type="button" size={size} onClick={onClick}>
      {children}
    </S.Button>
  )
}
